import { Slide } from '@/@types/Slide'

const randomValuesForFrustrations = new Array(50)
  .fill(null)
  .map(a => ({ x: Math.random() * 10 + 1, y: Math.random() * 10 + 1 }))

export default <Slide[]>[
  // {
  //   template: 'image-grid',
  //   title:
  //     '<span class="font-thin">Monitoring Report</span><br /><span class="font-bold">Serbia</span><br /><span class="font-thin">2019</span>',
  //   images: [
  //     'https://upload.wikimedia.org/wikipedia/commons/6/6c/Belgrade_Old_Court_1.jpg',
  //     'https://images.unsplash.com/photo-1554734867-bf3c00a49371?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
  //     'https://images.unsplash.com/photo-1545483656-1a34ae73add1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
  //     '/Monitoring-Report-2019-Serbia.png',
  //     'https://images.unsplash.com/photo-1509062522246-3755977927d7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1404&q=80',
  //     'https://images.unsplash.com/photo-1554256092-96709174126a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=701&q=80',
  //     'https://images.unsplash.com/photo-1550831107-1553da8c8464?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80',
  //     'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/%C5%BDS_413_006_3.jpg/1280px-%C5%BDS_413_006_3.jpg'
  //   ],
  //   subtitle:
  //     '<h3 class="text-center text-sigma-green text-4xl">Delivering services to the <strong>people</strong></h3>',
  //   logos: [require('@/assets/full-logo.jpg')],
  //   logo: `<p class="text-7xl font-thin font-serif text-white">Σ</p>`,
  //   slides: [
  //     {
  //       title: 'Citizens and businesses acknowledge improvements',
  //       blocks: [
  //         {
  //           component: 'vertical-bar',
  //           data: {
  //             labels: [[['Perceived quality with public'], ['services for citizens (%)']]],
  //             datasets: [
  //               {
  //                 backgroundColor: 'gray-600',
  //                 label: 2017,
  //                 data: [31]
  //               },
  //               {
  //                 backgroundColor: 'sigma-green',
  //                 label: 2019,
  //                 data: [45.9]
  //               }
  //             ]
  //           }
  //         },
  //         {
  //           component: 'vertical-bar',
  //           data: {
  //             labels: [[['Perceived quality with public'], ['services for businesses (%)']]],
  //             datasets: [
  //               {
  //                 backgroundColor: 'gray-600',
  //                 label: 2017,
  //                 data: [34.4]
  //               },
  //               {
  //                 backgroundColor: 'sigma-green',
  //                 label: 2019,
  //                 data: [54]
  //               }
  //             ]
  //           }
  //         },

  //         {
  //           component: 'vertical-bar',
  //           data: {
  //             labels: [[['Perceived efficiency of administrative'], ['procedures by citizens (%)']]],
  //             datasets: [
  //               {
  //                 backgroundColor: 'gray-600',
  //                 label: 2017,
  //                 data: [39.1]
  //               },
  //               {
  //                 backgroundColor: 'sigma-green',
  //                 label: 2019,
  //                 data: [51]
  //               }
  //             ]
  //           }
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    template: 'image-grid',
    title:
      '<span class="font-thin">Monitoring Report</span><br /><span class="font-bold">Serbia</span><br /><span class="font-thin">2019</span>',
    images: [
      'https://upload.wikimedia.org/wikipedia/commons/6/6c/Belgrade_Old_Court_1.jpg',
      'https://images.unsplash.com/photo-1554734867-bf3c00a49371?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
      'https://images.unsplash.com/photo-1545483656-1a34ae73add1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
      '/Monitoring-Report-2019-Serbia.png',
      'https://images.unsplash.com/photo-1509062522246-3755977927d7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1404&q=80',
      'https://images.unsplash.com/photo-1554256092-96709174126a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=701&q=80',
      'https://images.unsplash.com/photo-1550831107-1553da8c8464?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80',
      'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/%C5%BDS_413_006_3.jpg/1280px-%C5%BDS_413_006_3.jpg'
    ],
    subtitle:
      '<h3 class="text-center text-sigma-green text-4xl">Delivering services to the <strong>people</strong></h3>',
    logos: [require('@/assets/full-logo.jpg')],
    logo: `<p class="text-7xl font-thin font-serif text-white">Σ</p>`
  },
  {
    title: 'Summary in a nutshell',
    template: 'fullscreen',
    blocks: [
      {
        component: 'tracker',
        options: {
          filterOut: [1, 2, 22, 23],
          groupBy: {
            Why: [1],
            What: [2, 3, 4, 5, 6, 7, 8, 9],
            How: [10, 11, 12, 13, 14, 15]
          },
          groupColors: {
            Why: 'bg-sigma-green-light',
            What: 'bg-sigma-green',
            How: 'bg-sigma-green-dark'
          }
        }
      }
    ]
  },
  {
    title: '<strong>Good service delivery</strong> gives <strong>political leverage</strong>',
    template: 'steps',
    icons: [
      {
        name: 'group',
        class: 'fill-current mx-auto text-sigma-green-light-50'
      },
      {
        name: 'clipboard',
        class: 'fill-current mx-auto text-sigma-green-light'
      },
      {
        name: 'currency-dollar',
        class: 'fill-current mx-auto text-sigma-green'
      },
      {
        name: 'emotion-happy',
        class: 'fill-current mx-auto text-sigma-green-dark-50'
      },
      {
        name: 'thumb-up',
        class: 'fill-current mx-auto text-sigma-green-dark'
      }
    ],
    blocks: [
      `<p class="text-3xl my-4">Trust</p><p class="leading-loose">Satisfied users are <br/><span class="text-3xl font-bold leading-none">9x</span> more likely to trust government</p>`,
      `<p class="text-3xl my-4">Achievement</p><p class="leading-loose">Satisfied users are <br/><span class="text-3xl font-bold leading-none">9x</span> more likely to agree agencies achive their mission</p>`,
      `<p class="text-3xl my-4">Savings</p><p class="leading-loose">Dissatisfied users are <br/><span class="text-3xl font-bold leading-none">2x</span> more likely to reach out for help</p>`,
      `<p class="text-3xl my-4">Satisfaction</p><p class="leading-loose">Dissatisfied users are <br/><span class="text-3xl font-bold leading-none">2x</span> more likely to publicly express dissatisfaction</p>`,
      `<p class="text-3xl my-4">Engagement</p><p class="leading-loose">Long-term success is <br/><span class="text-3xl font-bold leading-none">50%</span> driven by its quality</p>`
    ],
    footer: `<p><strong>Source</strong>: <i>2018 Public Sector Journey Benchmark Survey</i>; Global results from Canada, U.S., Mexico, U.K., France and Germany, McKinsey</p>`,
    slides: [
      {
        title:
          '<p>... while <strong>poor services</strong> may</p><p>overshadow the <strong>best of experiences</strong></p>',
        template: 'steps',
        icons: [],
        blocks: [
          `<img class="rounded shadow-lg object-cover h-full w-full" src="https://images.unsplash.com/photo-1508847154043-be5407fcaa5a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1934&q=80"/>`,
          `<img class="rounded shadow-lg object-cover h-full w-full" src="${require('@/assets/administrative-burden.jpg')}"/>`
        ]
      }
      // {
      //   title: 'Identify the <strong>main frustrations</strong> for all services',
      //   template: 'focus',
      //   blocks: [
      //     {
      //       component: 'scatter',

      //       options: {
      //         tooltips: {
      //           enabled: false
      //         },
      //         areas: [
      //           {
      //             x1: 0,
      //             y1: 0,
      //             x2: '50%',
      //             y2: '50%',
      //             color: 'gray-600-25'
      //           },
      //           {
      //             x1: '50%',
      //             y1: 0,
      //             x2: '100%',
      //             y2: '50%',
      //             color: 'sigma-green-50',
      //             title: {
      //               text: 'High priority',
      //               color: 'sigma-green'
      //             }
      //           },
      //           {
      //             x1: 0,
      //             y1: '50%',
      //             x2: '50%',
      //             y2: '100%',
      //             color: 'gray-600-25'
      //           },
      //           {
      //             x1: '50%',
      //             y1: '50%',
      //             x2: '100%',
      //             y2: '100%',
      //             color: 'gray-600-25'
      //           }
      //         ],
      //         layout: {
      //           padding: 100
      //         },
      //         legend: {
      //           display: false
      //         },

      //         scales: {
      //           gridLines: { display: false },
      //           yAxes: [
      //             {
      //               scaleLabel: {
      //                 display: true,
      //                 fontSize: 30,
      //                 fontStyle: 'bold',
      //                 fontFamily: 'Poppins',
      //                 labelString: '- User frustration +'
      //               },
      //               gridLines: {
      //                 display: false
      //               },
      //               ticks: {
      //                 display: false,
      //                 min: 0,
      //                 max: Math.max(...randomValuesForFrustrations.map(c => c.y)) + 1
      //               }
      //             }
      //           ],
      //           xAxes: [
      //             {
      //               scaleLabel: {
      //                 display: true,
      //                 fontSize: 30,
      //                 fontStyle: 'bold',
      //                 fontFamily: 'Poppins',
      //                 labelString: '- Service frequency +'
      //               },
      //               gridLines: {
      //                 display: false
      //               },
      //               ticks: {
      //                 display: false,
      //                 min: 0,
      //                 max: Math.max(...randomValuesForFrustrations.map(c => c.x)) + 1
      //               }
      //             }
      //           ]
      //         }
      //       },
      //       data: {
      //         datasets: [
      //           {
      //             pointRadius: 10,
      //             pointHoverRadius: 10,
      //             data: randomValuesForFrustrations
      //           }
      //         ]
      //       }
      //     }
      //   ]
      // }
    ]
  },
  require('./../../data/service-delivery-modified.json'),

  {
    title: '<p>A governmental <strong>mind shift</strong> is needed</p><p>and Serbia could lead the way</p>',
    animated: true,
    template: 'versus',
    options: {
      arrows: 3
    },
    blocks: [
      `<div class="rounded-lg bg-gray-400 flex flex-col justify-center items-center md:h-1/2-screen min-h-full md:min-h-0 w-full">
        <p class="md:text-lg lg:text-3xl pt-8">Procedurial mindset</p>
        <ul class="text-left p-8 text-lg lg:text-3xl w-full md:w-2/3">
        <li class="flex py-4">A. <span class="ml-2">Mandate-bounded</span></li>
        <li class="flex py-4">B. <span class="ml-2">Skilled</span></li>
        <li class="flex py-4">C. <span class="ml-2">Traditional</span></li>
        </ul>
        </div>
        <p class="md:text-lg lg:text-3xl text-center hidden md:block">Compliance</p>`,
      `<div class="rounded-lg bg-sigma-green text-white flex flex-col justify-center items-center md:h-1/2-screen min-h-full md:min-h-0 w-full">
        <p class="md:text-lg lg:text-3xl pt-8">Citizen-oriented mindset</p>
        <ul class="text-left p-8 text-lg lg:text-3xl w-full md:w-2/3">
        <li class="py-4">Mission-driven</li>
        <li class="py-4">User-centered</li>
        <li class="py-4">Digital</li>
        </ul>
        </div>
        <p class="md:text-lg lg:text-3xl text-center hidden md:block">Purpose</p>`
    ]
  },
  {
    title: '<span class="text-white">Deliver as one government</span>',
    template: 'transition',
    background:
      'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80'
  },
  {
    title: '<span>Recommendations: <strong>deliver as one government</strong></span>',
    subtitle: '<span class="font-thin not-italic">From <b>mandate-bounded</b> to <b>mission-driven</b></span>',
    template: 'steps',
    footer: '<div/>',
    icons: [
      {
        name: 'group',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      },
      {
        name: 'cog',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      },
      {
        name: 'user-check',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      }
    ],
    blocks: [
      `<div class="tip text-xl lg:text-3xl">
      
      Build inter-disciplinary <br/>teams</h2><h2 class="my-4 mx-auto block rounded-full h-12 w-12 bg-sigma-green text-white font-bold">1</h2>
      
      <span class="tip-content">The Government should continue with the transformation of administrative services into user-friendly ones by supporting individual agencies with various tools to overcome legal, technological and administrative hurdles. For that purpose, the support provided by the e-Gov Office, the Delivery Unit and the PPS should be reinforced by deploying interdisciplinary teams to guide with the simplification and re-design of life-event related services.</span>
      
      `,
      `<div class="tip text-xl lg:text-3xl">Lead the <br/>transformation</h2><h2 class="my-4 mx-auto block rounded-full h-12 w-12 bg-sigma-green text-white font-bold">2</h2>
      
      <span class="tip-content">A clear message – preferably by the Prime Minister - should be communicated to the senior managers indicating that they are responsible for and should therefore take the lead role in service transformation in their work area to deploy the enablers in place.</span>
      `,
      `<div class="tip text-xl lg:text-3xl">Assign clear <br/>responsibilities</h2><h2 class="my-4 mx-auto block rounded-full h-12 w-12 bg-sigma-green text-white font-bold">3</h2>
      
      <span class="tip-content">The Government should clearly assign responsibility for developing service delivery across the administration to a relevant body/bodies. Such responsibility should include the elaboration of a comprehensive policy for ensuring and improving accessibility to the public services, installing an effective monitoring system over service delivery improvements, organising exchanges of best practices and further developing policies and standards in the service delivery area.</span>`
    ]
  },
  {
    title: '<span class="text-white">Bring the users to the table</span>',
    template: 'transition',
    background: require('@/assets/bring-the-users.jpg')
  },
  {
    subtitle:
      '<span class="font-thin not-italic">From <strong>skilled public servants</strong> to <strong>user-centered public service</strong></span>',
    title: '<span>Recommendations: <strong>bring the users to the table</strong></span>',
    template: 'steps',
    icons: [
      {
        name: 'thumb-up',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      },
      {
        name: 'emotion-happy',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      },
      {
        name: 'search',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      }
    ],
    footer: `<div/>`,
    blocks: [
      `<div class="tip text-xl lg:text-3xl">Engage with <br/>users </h2><h2 class="my-4 mx-auto block rounded-full h-12 w-12 bg-sigma-green text-white font-bold">7</h2><span class="tip-content">The Government should introduce a policy on user engagement into service delivery improvement across the administration, from identifying the needs of the user to analysing feedback on quality and accessibility in order to inform of further improvements.</span>`,
      `<div class="tip text-xl lg:text-3xl">Ensure accessibility <br/>for all people </h2><h2 class="my-4 mx-auto block rounded-full h-12 w-12 bg-sigma-green text-white font-bold">8</h2><span class="tip-content">The Government should significantly improve public service accessibility for people with disabilities across different public service providers all over the country. A regular public report on the efforts of government bodies and municipalities concerning the situation with accessibility to public services for people with disabilities should be published.</span>`,
      `<div class="tip text-xl lg:text-3xl">Examine user <br/>experiences</h2><h2 class="my-4 mx-auto block rounded-full h-12 w-12 bg-sigma-green text-white font-bold">7</h2><span class="tip-content">The Government should introduce a policy on user engagement into service delivery improvement across the administration, from identifying the needs of the user to analysing feedback on quality and accessibility in order to inform of further improvements.</span>`
    ]
  },
  {
    title: '<span class="text-white">Take full advantage of digitalization</span>',
    template: 'transition',
    background:
      'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=2250&q=80'
  },
  {
    subtitle:
      '<span class="font-thin not-italic">From <strong>traditional procedures</strong> to <strong>digital delivery</strong>:</span>',
    title: 'Recommendations: <strong>take full advantage of digitalization</strong>',
    template: 'steps',
    icons: [
      {
        name: 'repeat',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      },
      {
        name: 'edit',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      },
      {
        name: 'announcement',
        class: 'lg:h-48 lg:w-48 md:h-32 md:w-32 mx-auto'
      }
    ],
    footer: `<div/>`,
    blocks: [
      `<div class="tip text-xl lg:text-3xl">Embrace <br/>“once only” principle </h2><h2 class="my-4 mx-auto block rounded-full h-12 w-12 bg-sigma-green text-white font-bold">5</h2><span class="tip-content">The e-Gov Office with the backing of the Government should ensure the implementation of the interoperability framework. Rules should be established and enforced to grant legitimate dataseekers access to registries to apply the ‘once only’ principle and allow for pre-filled digital application forms in practice. </span>`,

      `<div class="tip text-xl lg:text-3xl">Promote digital</br>signature </h2><h2 class="my-4 mx-auto block rounded-full h-12 w-12 bg-sigma-green text-white font-bold">4</h2><span class="tip-content">The e-Gov Office should make sure that the digital signature becomes more appealing and convenient for individual citizens, by ensuring the successful launch of mobile phone-based solutions in co-operation with other stakeholders and by active promotion of the digital signature across the administration as well as among citizens.</span>`,
      `<div class="tip text-xl lg:text-3xl">Communicate</br>your services </h2><h2 class="my-4 mx-auto block rounded-full h-12 w-12 bg-sigma-green text-white font-bold">6</h2><span class="tip-content">The MPALSG and the PPS should strengthen co-ordination between the harmonisation of special laws and relevant by-laws with the LGAP and administrative simplification efforts. The Government should raise awareness of all the public administration bodies delivering public services as well as the service users about the key principles of LGAP to accelerate the implementation of LGAP.</span>`
    ]
  },
  {
    title: '<strong>Thank you</strong><br/> for listening',
    template: 'introduction',
    logos: [require('@/assets/full-logo.jpg')],
    blocks: [
      {
        component: 'map',
        options: {
          map: 'europe',
          zoom: 7
        },
        data: {
          datasets: [
            {
              data: ['Serbia']
            }
          ]
        }
      },

      `<div class="self-center mx-auto text-justify w-4/5 lg:w-2/4 xl:w-1/5 bg-white border-2 border-dashed border-gray-600 p-4 lg:p-8 rounded-lg pointer-events-auto">
      <div class="flex justify-between text-sm md:text-normal ">
      <a class="text-center block" href="http://www.sigmaweb.org/publications/Monitoring-Report-2019-Serbia.pdf" target="_blank">
      <p class="mb-2 md:mb-8">Download the full report</p>
      <img class="h-8 md:h-12 mx-auto" src="/svg-icons/icon-download.svg"/>
      </a>
      <a class="text-center block" href="mailto:?subject=Monitoring Report 2019 - Serbia&body=Please follow this link to see the full Monitoring Report 2019 on Serbia: https://sigma.apenhet.com/service-delivery-2019.">
      <p class="mb-2 md:mb-8">Share this presentation</p>
      <img class="h-8 md:h-12 mx-auto" src="/svg-icons/icon-mail.svg"/>
      </a>
      </div>
      </div>`,
      `<div class="pointer-events-auto self-center bottom-0 absolute lg:bottom-0 text-sm md:text-normal lg:right-0 lg:mb-8 mb-16 md:mb-32 w-full mx-auto text-justify w-4/5 lg:w-1/2 xl:w-1/5 bg-white border-2 border-dashed border-gray-600 p-4 lg:p-8 rounded-lg lg:mr-8"><p class="text-left">For mor information, please do not hesitate to contact us at <a href="mailto:Annika.UUDELEPP@oecd.org">Annika.UUDELEPP@oecd.org</a> or visit the <strong><a href="http://sigmaweb.org" target="_blank">SIGMA</a></strong> website.<br/><br/>For technical issues, contact <strong><a href="mailto:contact@apenhet.com">Åpenhet</a></strong>.</p></div>`
    ]
  }
]
